import { UserTimezoneActions } from "../constants/actionTypes"
import { IUserTimezone } from "../interfaces/IAppState"

const IndianTimezones = ["Asia/Kolkata", "Asia/Calcutta"]

function init(): any {
	const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const isCurrentTimezoneIST = IndianTimezones.includes(currentTimezone)
	return {
		timezone: currentTimezone,
		isInternational: false,
		nationalTimezones: isCurrentTimezoneIST ? IndianTimezones : [currentTimezone],
	} as IUserTimezone
}

export const userTimezoneReducer = (state = init(), action: any): any => {
	switch (action.type) {
		case UserTimezoneActions.UPDATE_USER_TIMEZONE:
			return {
				...state,
				...(action?.payload || ({} as IUserTimezone)),
			}
		case UserTimezoneActions.UPDATE_NATIONAL_TIMEZONE:
			return {
				...state,
				nationalTimezones: action.payload,
			}
		default:
			return state
	}
}
